import { Box } from '@mui/material';
import { FC, useEffect, useState } from 'react';

import styles from './components.module.css';
import CustomButton from 'shared/custom-button/CustomButton';

import CurrencyRubleIcon from '@mui/icons-material/CurrencyRuble';
import { useAppDispatch, useAppSelector } from 'shared/utils/hooks/useRedux';
import { IdCaseSpecialPogramInfo, LastFetchTimeSpecialPogramInfo, LoadingSpecialPogramInfo, SpecialPogramInfo } from 'entities/insurance-contract/special-pogram/selector';
import { isValidIdCase } from 'shared/utils/hooks/useValidationIdCase';
import { fetchSpecialPogram } from 'entities/insurance-contract/special-pogram/actions/fetch-special-program';
import Loader from 'shared/loader/Loader';

interface SpecialPogram {
    idCase: string;
}

export const SpecialPogram: FC<SpecialPogram> = ({ idCase }) => {

    const dispatch = useAppDispatch();
    const specialPogramData = useAppSelector(SpecialPogramInfo);
    const lastFetch = useAppSelector(LastFetchTimeSpecialPogramInfo);
    const storedIdCase = useAppSelector(IdCaseSpecialPogramInfo);

    const isLoading = useAppSelector(LoadingSpecialPogramInfo);

    const [isValid, setIsValid] = useState(true);

    const fetchCaseWithValidation = () => {
        if (isValidIdCase(idCase)) {
            dispatch(fetchSpecialPogram({ idCase }));
        } else {
            setIsValid(false)
            console.error('Invalid idCase');
        }
    };

    useEffect(() => {
        if (idCase) {
            const currentTime = Date.now();
            const oneDay = 24 * 60 * 60 * 1000;
            const isIdChanged = idCase !== storedIdCase;
            const isDataStale = !lastFetch || (currentTime - lastFetch) > oneDay;

            if (isIdChanged || isDataStale) {
                fetchCaseWithValidation();
            }
        } else {
            console.error('Missing idCase');
        }
    }, [dispatch, idCase, lastFetch, storedIdCase]);

    const handleForceRefresh = () => {
        fetchCaseWithValidation();
    };

    return (
        <>
            {isLoading ? (
                <Loader
                    title='Загрузка...'
                />
            ) : (
                <Box className={styles.shadowBoxSpecialProgram}>
                    <Box className={styles.contentRow}>
                        <Box className={styles.contentColumn}><span>Лимит по договору</span><p className={styles.icon}>{specialPogramData.InsuranceSumSectionA} <CurrencyRubleIcon /></p></Box>
                        <Box className={styles.contentColumn}><span>Выплаты в Клиники</span><p className={styles.icon}>{specialPogramData.PaymentsToHospitals} <CurrencyRubleIcon /></p></Box>
                    </Box>
                    <Box className={styles.contentRow}>
                        <Box className={styles.contentColumn}><span>Резерв по ГП</span><p className={styles.icon}>{specialPogramData.ReserveUnderGuaranteeLetters} <CurrencyRubleIcon /></p></Box>
                        <Box className={styles.contentColumn}><span>Резерв по ГП (РВЛ)</span><p className={styles.icon}>{specialPogramData.ReserveUnderGuaranteeLettersRehabilitation} <CurrencyRubleIcon /></p></Box>
                        <Box className={styles.contentColumn}><span>Остаток лимита</span><p className={styles.icon}>{specialPogramData.ResidualPremium} <CurrencyRubleIcon /></p></Box>
                    </Box>
                    <Box className={styles.updateBtnBox}>
                        <CustomButton
                            title="Обновить данные"
                            handleClick={handleForceRefresh}
                            textColor="white"
                            backgroundColor="#0054E6"
                            padding="5px 30px"
                            gap="10px"
                            border='none'
                            borderRadius='4px'
                        />
                    </Box>
                </Box>
            )}
        </>



    )
}

